import { WalkthroughContentDto } from './WalkthroughContentDto';

export interface WalkthroughPathsDictionary {
  [key: string]: WalkthroughContentDto;
}
